import React, { useState, useEffect } from "react";
import Topnavbar from "../dashboard/topnavbar";
import Sidennav from "../dashboard/sidenavbar";
import axios from "axios";
import { baseurladdress } from "../baseurl"
import Swal from "sweetalert2";
import $ from 'jquery';

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 1800,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

const JobApplicants = () => {
  const [tableData, setTableData] = useState([]);
  const accesstoken = localStorage.getItem("token");

  useEffect(() => {
    const GetAllApplicants = () => {
      axios
        .get(baseurladdress + `getallapplicants`, {
          headers: {
            Authorization: `Bearer ${accesstoken}`,
          },
        })
        .then(res => {
          const datas = res.data.response;
          console.log("Applicants:", datas);

          const tdata = datas.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.job_title}</td>
              <td>{item.applicant_name}</td>
              <td>{item.applicant_email}</td>
              <td>{item.branch_name}</td>
              <td>
                {item.applicant_resume ? (
                  <a
                    href={baseurladdress + "cvfiles/" + item.applicant_resume}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-primary"
                  >
                    View / Download
                  </a>
                ) : (
                  "No CV"
                )}
              </td>
              <td>
                <div style={{ textAlign: "left" }}>
                  {(() => {
                    if (item.application_status == 0) {
                      return <span className="badge bg-danger">Not Selected</span>;
                    } else if (item.application_status == 1) {
                      return <span className="badge bg-primary">CV Selected</span>;
                    } else if (item.application_status == 2) {
                      return <span className="badge bg-warning">Processing</span>;
                    } else if (item.application_status == 3) {
                      return <span className="badge bg-info">Recruited</span>;
                    } else if (item.application_status == 4) {
                      return <span className="badge bg-success">Appointed</span>;
                    }
                  })()}
                </div>
              </td>
            </tr>
          ));

          setTableData(tdata);
        })
        .catch(error => {
          Swal.fire({
            icon: 'error',
            title: 'No applicants found'
          });
        });
    };

    GetAllApplicants();
  }, []);

  $(function () {
    setTimeout(function () {
      $('#applicantlist').DataTable();
    }, 1000);
  });

  return (
    <div>
      <Topnavbar />

      <Sidennav />
      <div className="content-wrap">
        <div className="main">
          <div className="container-fluid">

            <section id="main-content">
              <div className="card">
                <div className="card-header" style={{ color: "black" }}>
                  <h6 className="card-title">Job Applicants</h6>
                </div>

                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-sm-3">
                      <select
                        id="statusFilter"
                        className="form-control"
                        onChange={(e) => {
                          const value = e.target.value;
                          const table = $('#applicantlist').DataTable();
                          if (value) {
                            table.column(6).search(value).draw();
                          } else {
                            table.column(6).search('').draw();
                          }
                        }}
                      >
                        <option value="">All Status</option>
                        <option value="Not Selected">Not Selected</option>
                        <option value="CV Selected">CV Selected</option>
                        <option value="Processing">Processing</option>
                        <option value="Recruited">Recruited</option>
                        <option value="Appointed">Appointed</option>
                      </select>
                    </div>
                  </div>
                  <div className="table-responsive p-2">
                    <table className="table table-bordered table-responsive-sm" id="applicantlist">
                      <thead>
                        <tr>
                          <th>Sl.No</th>
                          <th>Job Title</th>
                          <th>Applicant Name</th>
                          <th>Email</th>
                          <th>Branch</th>
                          <th>Resume</th>
                          <th style={{ textAlign: "left" }}>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>


            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobApplicants;
